// Module
var code = `<miscellaneous-transactions-page header-title="\$ctrl.header" form-title="\$ctrl.header | uppercase">
  <h2 class="section-header">Please confirm the following:</h2>
  <form name="\$ctrl.transactionForm">
    <table class="misc-transaction__table table table--generate-row-ids">
      <tbody>
        <tr ng-if="\$ctrl.interbranch || \$ctrl.target === 'BRANCH'">
          <td></td>
          <td>Target branch:</td>
          <td>
            <selectize
              options="\$ctrl.branches"
              ng-model="\$ctrl.transaction.targetBranchId"
              config="\$ctrl.targetBranchSelectConfig"
              class="nx-selectize"
              ng-change="\$ctrl.updateDepositoryAccounts()"
              required
          ></selectize>
          </td>
        </tr>
        <tr ng-if="\$ctrl.target === 'DEPOSITORY_BANK'">
          <td></td>
          <td>Deposit bank account:</td>
          <td>
            <selectize options="\$ctrl.depositoryAccounts"
                       config="\$ctrl.selectConfig"
                       ng-model="\$ctrl.transaction.depositoryAccountId"
                       ng-required="true"></selectize>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Remarks:</td>
          <td>
            <input
                type="text"
                maxlength="512"
                ng-model="\$ctrl.transaction.remarks"
                required/>
          </td>
        </tr>
      </tbody>
    </table>

    <check-list-wrapper transfer-status="'TRANSFERRED_TO_CASHIER'"
                        on-check-change="\$ctrl.onCheckChange(checkedRecords)"
    ></check-list-wrapper>

    <table class="misc-transaction__table table">
      <thead>
        <tr>
          <th></th>
          <th>Check amount to deposit</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
      <tr>
        <td>1</td>
        <td>Amount to deposit:</td>
        <td>
          <cash ng-model="\$ctrl.amount"
                ng-disabled="true"
                ng-required="true"></cash>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="summary-actions">
      <button
          class="btn btn-warning"
          type="button"
          ng-click="\$ctrl.cancelChanges()">
        Cancel
      </button>
      <button
          type="submit"
          class="btn btn-success"
          ng-disabled="\$ctrl.transactionForm.\$invalid || \$ctrl.transaction.checkIds.length === 0"
          ng-click="\$ctrl.save()">
        Deposit
      </button>
    </div>
  </form>
</miscellaneous-transactions-page>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/check-deposit/check-deposit.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;